import React from "react";
import { config } from "../../../../config";
import ReactQuill from "react-quill"; // ReactQuill ইম্পোর্ট
import "react-quill/dist/quill.snow.css"; // Quill এর স্টাইল ইম্পোর্ট


const imageUrl = config.imageUrl;

const UpdateThank = ({ formData, handleChange, handleQuillChange, handleSubmit, onCancel, loading, error }) => {
  return (
    <div className="p-6 max-w-lg mx-auto bg-white shadow rounded">
      <h2 className="text-2xl font-bold mb-4">Update Thank You Page</h2>

      {/* Display Loading State */}
      {loading && <p className="text-blue-500 mb-4">Updating...</p>}

      {/* Display Error Message */}
      {error && <p className="text-red-500 mb-4">{error}</p>}

      <form onSubmit={handleSubmit}>
        {/* Top Bar */}
        <div className="mb-4">
          <label className="block text-gray-700 font-medium">Top Bar</label>
          <input
            type="text"
            name="topBar"
            value={formData.topBar}
            onChange={handleChange}
            className="border w-full p-2"
            placeholder="Enter top bar text"
          />
        </div>

        {/* Headline */}
        <div className="mb-4">
          <label className="block text-gray-700 font-medium">Headline</label>
          <input
            type="text"
            name="headline"
            value={formData.headline}
            onChange={handleChange}
            className="border w-full p-2"
            placeholder="Enter headline"
            required
          />
        </div>

        {/* Sub Headline */}
        <div className="mb-4">
          <label className="block text-gray-700 font-medium">Sub Headline</label>
          <input
            type="text"
            name="subHeadline"
            value={formData.subHeadline}
            onChange={handleChange}
            className="border w-full p-2"
            placeholder="Enter sub headline"
          />
        </div>

        {/* Important Message
        <div className="mb-4">
          <label className="block text-gray-700 font-medium">Important Message</label>
          <textarea
            name="importantMessage"
            value={formData.importantMessage}
            onChange={handleChange}
            className="border w-full p-2"
            placeholder="Enter important message"
          ></textarea>
        </div> */}

        {/* Slug */}
        <div className="mb-4">
          <label className="block text-gray-700 font-medium">Slug</label>
          <input
            type="text"
            name="slug"
            value={formData.slug}
            onChange={handleChange}
            className="border w-full p-2"
            placeholder="Enter slug"
          />
        </div>

         {/* Image */}
         <div className="mb-4">
          <label className="block text-gray-700 font-medium">Image</label>
          <input
            type="file"
            name="image"
            onChange={handleChange}
            className="border w-full p-2"
          />
        </div>

        {/* Video */}
        <div className="mb-4">
          <label className="block text-gray-700 font-medium">Video</label>
          {formData.video && (
            <video src={`${imageUrl}/${formData.video}`} controls width="200" className="mb-2" />
          )}
          <input
            type="text"
            name="video"
            value={formData.video}
            onChange={handleChange}
            className="border w-full p-2"
          />
        </div>

        <div className="mb-4">
          <label className="flex items-center">
            <input
              type="checkbox"
              name="showImage"
              checked={formData.showImage}
              onChange={handleChange}
              className="mr-2"
            />
            শুধুমাত্র ইমেজ দেখান
          </label>
        </div>


        {/* Steps
        <div className="mb-4">
          <label className="block text-gray-700 font-medium">Steps</label>
          <ReactQuill
            value={formData.steps || ""} // Ensure Quill gets a valid string
            onChange={handleQuillChange}
            className="border w-full p-2"
          />

        </div> */}

        {/* Ticket Text */}
        <div className="mb-4">
          <label className="block text-gray-700 font-medium">আপনার ওয়েবিনার এক্সেস (Your Webinar Access)</label>
          <input
            type="text"
            name="ticketText"
            value={formData.ticketText}
            onChange={handleChange}
            className="border w-full p-2"
            placeholder="Enter ticket text"
          />
        </div>

        {/* Webinar Headline */}
        <div className="mb-4">
          <label className="block text-gray-700 font-medium">ওয়েবিনার শুরু হতে কতক্ষন বাকি (এই টাইপের লেখা দিন)</label>
          <input
            type="text"
            name="webinarHeadline"
            value={formData.webinarHeadline}
            onChange={handleChange}
            className="border w-full p-2"
            placeholder="Enter webinar headline"
          />
        </div>

        {/* Webinar Starts In */}
        <div className="mb-4">
          <label className="block text-gray-700 font-medium">ওয়েবিনার শুরু হতে কতক্ষন বাকি</label>
          <input
            type="text"
            name="webinarStartsIn"
            value={formData.webinarStartsIn}
            onChange={handleChange}
            className="border w-full p-2"
            placeholder="Enter time until webinar starts"
          />
        </div>

        {/* Webinar Starts Text */}
        <div className="mb-4">
          <label className="block text-gray-700 font-medium">ওয়েবিনার নির্দিষ্ট কখন শুরু হবে(লেখা)</label>
          <input
            type="text"
            name="webinarStartsText"
            value={formData.webinarStartsText}
            onChange={handleChange}
            className="border w-full p-2"
            placeholder="Enter webinar starts text"
          />
        </div>

        {/* Webinar Paragraph
        <div className="mb-4">
          <label className="block text-gray-700 font-medium">Webinar Paragraph</label>
          <textarea
            name="webinarParagraph"
            value={formData.webinarParagraph}
            onChange={handleChange}
            className="border w-full p-2"
            placeholder="Enter webinar paragraph"
          ></textarea>
        </div> */}

        {/* Webinar Button Text */}
        <div className="mb-4">
          <label className="block text-gray-700 font-medium">ওয়েবিনারের বাটন টেক্সট</label>
          <input
            type="text"
            name="webinarButtonText"
            value={formData.webinarButtonText}
            onChange={handleChange}
            className="border w-full p-2"
            placeholder="Enter webinar button text"
          />
        </div>

        {/* Redirect Page */}
        <div className="mb-4">
          <label className="block text-gray-700 font-medium">রিডাইরেক্ট পেইজ</label>
          <input
            type="text"
            name="redirectPage"
            value={formData.redirectPage}
            onChange={handleChange}
            className="border w-full p-2"
            placeholder="Enter Redirect Page"
          />
        </div>

        {/* <div className="mb-4">
          <label className="block text-gray-700">Facebook Pixel Id</label>
          <input
            name="pixelId"
            value={formData.pixelId}
            onChange={handleChange}
            className="border w-full p-2"
          />
        </div> */}

        {/* Submit Button */}
           <div className="flex justify-end space-x-3">
             <button
              type="button"
              onClick={onCancel}
              className="bg-gray-500 text-white px-6 py-2 rounded hover:bg-gray-600"
              disabled={loading}
            >
              Cancel
            </button>
            <button
              type="submit"
              className="bg-blue-600 text-white px-4 py-2 rounded hover:bg-blue-700"
              disabled={loading}
            >
              {loading ? "Updating..." : "Update Thank You Page"}
            </button>
        </div>
       
      </form>
    </div>
  );
};

export default UpdateThank;
